import { Injectable } from "@angular/core";
import { RisrFormTypeExpander, RisrExpandableField, RisrSchemaField } from "@fry-it/risr-core";


/**
 * This expander is responsible for expanding blueprint fields
 *
 * @category Forms
 * @example
 * ```typescript
 * const field = {
 *     id: 'blueprint',
 *     label: 'Blueprint',
 *     expandType: 'blueprint',
 *     required: true,
 *     initialValue: []
 * };
 * const expanded = await this.formExpander.expand(field);
 * ```
 */
@Injectable()
export class BlueprintFieldExpander implements RisrFormTypeExpander {
    provideTypes: string[] = ['blueprint'];
    async expand(field: RisrExpandableField): Promise<RisrSchemaField> {
        return {
            name: field.id,
            label: field.label,
            type: 'discrete_multiple',
            required: field.required,
            options: {
                categories: [
                    { name: 'blueprints', label: 'Blueprints' }
                ]
            },
            initialValue: field.initialValue
        }
    }
}